import "./ScaffoldingInBeaconsfield.module.css";
import Header from "@/reusable_sections/Header";
import Beaconsfield from "./sections/Beaconsfield";
import LocalIntro from "./sections/LocalIntro";
import BeaconsfieldCoverage from "./sections/BeaconsfieldCoverage";
import BeaconsfieldAccess from "./sections/BeaconsfieldAccess";
import BeaconsfieldFaq from "./sections/BeaconsfieldFaq";
import Finalcta from "./sections/Finalcta";
import Footer from "@/reusable_sections/Footer";
export default function ScaffoldingInBeaconsfieldPage() {
  return <div>
      <Header />
      <Beaconsfield />
      <LocalIntro />
      <BeaconsfieldCoverage />
      <BeaconsfieldAccess />
      <BeaconsfieldFaq />
      <Finalcta />
      <Footer />
    </div>;
}